/**
 * Utilidad optimizada para gestión de caché en localStorage
 */

// Lista de claves problemáticas que deben limpiarse
const PROBLEMATIC_KEYS = [
  'infoPersonal',
  'infoDependiente',
  'infoIndependiente', 
  'infoDesempleado',
  'infoPensionado',
  'infoFinanciera',
  'infoReferencias'
];

// Claves esenciales que no deben eliminarse durante la limpieza
const ESSENTIAL_KEYS = [
  'token', 
  'id', 
  'censado', 
  'token-init-date', 
  'tokenClarisa', 
  'rol'
];

/**
 * Limpia la caché en el momento del login
 * @returns {number} Número de elementos limpiados
 */
export const cleanCacheOnLogin = () => {
  // Almacenar valores esenciales
  const essentialData = {};
  
  // Guardar todos los valores esenciales
  ESSENTIAL_KEYS.forEach(key => {
    const value = localStorage.getItem(key);
    if (value) essentialData[key] = value;
  });
  
  // Limpiar completamente localStorage
  localStorage.clear();
  
  // Restaurar valores esenciales
  Object.entries(essentialData).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
  
  // Devolver cantidad de elementos limpiados (aproximación)
  return PROBLEMATIC_KEYS.length;
}; 